import { render } from "./editPayment.vue?vue&type=template&id=4f64ffa9&scoped=true"
import script from "./editPayment.vue?vue&type=script&lang=js"
export * from "./editPayment.vue?vue&type=script&lang=js"

import "./editPayment.vue?vue&type=style&index=0&id=4f64ffa9&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f64ffa9"]])

export default __exports__